import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { warn } from '../utils/logger.js';
import './baseRequest.js';
import { PLATFORMS } from '../constants/platforms.js';
import settings from '../settings.js';
import { webPreparePurchase } from './platform/web/webPreparePurchase.js';
import { PREPARE_NEXT_ACTION_CODES } from '../constants/web/nextActionCodes.js';
import '../constants/web/threeDSStatuses.js';
import { TSV_METHODS_MAP } from '../constants/web/tsvMethods.js';
import '../constants/web/tsvMethodsErrorCodes.js';
import { updateActivePaymentMethod } from '../store/activePaymentMethod.js';
import { setBindingManagementUrl } from '../store/bindingManagementUrl.js';
import { setNextPaymentAction } from '../store/nextPaymentAction.js';
import { setPaymentMethods } from '../store/paymentMethods.js';
import { setMethod } from '../store/purchaseTwoFactor.js';
import { setTransactionId } from '../store/transactionId.js';
import { setTsv } from '../store/tsv.js';
import detectPlatform from '../utils/detectPlatform.js';

function filterPaymentMethods(clientPaymentMethods, product) {
    return clientPaymentMethods.filter((clientPaymentMethod) => product.clientPaymentMethods.includes(clientPaymentMethod.id));
}
function preparePurchaseForWeb(product, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { transactionId, bindingManagementUrl, clientPaymentMethods, nextAction, tsv } = yield webPreparePurchase(product.code, product.currency, product.price, product.quantity, null, storefrontName || settings.storefrontName);
            let paymentMethods = filterPaymentMethods(clientPaymentMethods, product);
            if (nextAction && nextAction.actionCode === PREPARE_NEXT_ACTION_CODES.CHOOSE_PAYMENT_GROUP) {
                paymentMethods = [];
            }
            setTransactionId(transactionId);
            setBindingManagementUrl(bindingManagementUrl);
            setPaymentMethods(paymentMethods);
            updateActivePaymentMethod(paymentMethods || []);
            setTsv(tsv);
            setMethod(TSV_METHODS_MAP[tsv.method] || tsv.method);
            setNextPaymentAction(nextAction);
        }
        catch (e) {
            updateActivePaymentMethod([]);
            warn('Failed prepare purchase request');
        }
    });
}
function preparePurchaseByPlatform(product, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const platform = detectPlatform();
        switch (platform) {
            case PLATFORMS.WEB: {
                yield preparePurchaseForWeb(product, storefrontName);
                break;
            }
        }
    });
}

export { preparePurchaseByPlatform as default };
//# sourceMappingURL=fetchInfo.js.map
